import {gql} from "@apollo/client/core";

export const EmailVerificationStatusQuery = gql`
    query EmailVerificationStatus($vti: String)
    {
        emailVerificationStatus(vti: $vti) {
            state
            rejectReason
        }
    }
`;
